/* payment/commonview/lib/view-confirmationmessage.js */

/* This is an updated extraction of the notifications module to be loaded using commonJS */
import core from '../../common/lib/core.js';

const elements = {};
let removeListeners = null;
let confirmationCallback = null;
let confirmButtonText;
let iconId = null;
let messageText;
let mainTitleText;

// TODO; this commented code is kept for a while (oct 14 2016) until autohide is implemented
// function showConfirmationMessage(iconIdentifier, titleText, messageText, buttonText, confirmCallback, effect) {
// 	const $confirmationWrapper = $globalNotificationsContainer.find('.js-confirm-modal');

// 	const titleElement = $confirmationWrapper.find('.js-notify__main-title');

// 	const messageElement = $confirmationWrapper.find('.js-notify__p');

// 	const buttonElement = $confirmationWrapper.find('.js-notify__button-wrapper');
// 	const confirmationCallback = confirmCallback || function empty() {};
// 	const confirmationEffect = (effect && $.inArray(effect, validEffects) >= 0) ? effect : '';
// 	titleElement.text(titleText);
// 	messageElement.text(messageText);
// 	buttonElement.find('button').text(buttonText).removeClass('u-hide')
// 		.addClass('u-show');
// 	$globalNotificationsContainer.addClass('global-notification--is-open');
// 	$confirmationWrapper.addClass(`notify--is-open ${confirmationEffect}`);
// 	/* setTimeout(function () {
// 		$confirmationWrapper.removeClass('notify--is-open');
// 		$(titleElement, messageElement, buttonElement.find('button')).text('');
// 		buttonElement.removeClass('u-show').addClass('u-hide');
// 		}, 3000); */
// 	buttonElement.on('click', (e) => {
// 		e.preventDefault();
// 		confirmationCallback();
// 		closeNotifyWrapper($confirmationWrapper);
// 	});
// }

function selectElements() {
	elements.wrap = (elements.wrap || document.querySelector('.js-global-notification'));
	/* this wrapper is put into below the #container div and in one occurence per casino, shop and ... */
	elements.wrapSubContent = (elements.wrapSubContent || elements.wrap.querySelector('.js-confirm-modal'));
	elements.iconWrapper = elements.wrapSubContent.querySelector('.js-notify__icon-wrapper');
	elements.icon = elements.iconWrapper.querySelector(`.${iconId}`);
	elements.mainTitle = (elements.mainTitle || elements.wrapSubContent.querySelector('.js-title'));
	elements.mainText = (elements.mainText || elements.wrapSubContent.querySelector('.js-text'));
	elements.buttonWrapper = (elements.buttonWrapper || elements.wrapSubContent.querySelector('.js-notify__button-wrapper'));
	elements.buttonElement = (elements.buttonElement || elements.buttonWrapper.querySelector('.js-button '));
}

function showIcon() {
	core.addClass(elements.icon, 'u-show');
	core.removeClass(elements.icon, 'u-hide');
}

function setTexts() {
	elements.mainTitle.innerHTML = mainTitleText;
	elements.buttonElement.innerHTML = confirmButtonText;
	elements.mainText.innerHTML = messageText;
}

function openWrappers() {
	core.addClass(elements.wrap, 'global-notification--is-open');
	core.addClass(elements.wrapSubContent, 'notify--is-open');
}

function closeWrappers() {
	core.removeClass(elements.wrap, 'global-notification--is-open');
	core.removeClass(elements.wrapSubContent, 'notify--is-open');
}

function close() {
	removeListeners();
	closeWrappers();
}

function clickYesHandler() {
	close();
	confirmationCallback();
}

function addListeners() {
	elements.buttonElement.addEventListener('click', clickYesHandler);
}
/* this function is stored with a name different from the containing variable,
to solve the 'no-shadow' and the 'no use before define' linting rules.
*/
removeListeners = function removeListenersFkn() {
	if (elements && elements.buttonElement) {
		elements.buttonElement.removeEventListener('click', clickYesHandler);
	}
};

export default {
	show(iconIdentifier, titleTxt, mainTxt, okBtnTxt, confirmCb) {
		confirmationCallback = (confirmCb || function empty() {});
		iconId = (iconIdentifier || 'default-success');
		messageText = (mainTxt || 'The action you requested could not be fulfilled. Try again later or contact customerservice.');
		confirmButtonText = (okBtnTxt || 'Ok');
		mainTitleText = (titleTxt || 'Could not complete.');
		selectElements();
		setTexts();
		showIcon();
		addListeners();
		openWrappers();
	},
	close() {
		close();
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/commonview/lib/view-confirmationmessage.js